import { useLayoutEffect, useState } from 'react';
import * as am5 from "@amcharts/amcharts5";
import * as am5xy from "@amcharts/amcharts5/xy";
import am5themes_Animated from "@amcharts/amcharts5/themes/Animated";

function LineChartPeaksPreview(props) {




  useLayoutEffect(() => {
    var root = am5.Root.new("chartdiv");


// Set themes
// https://www.amcharts.com/docs/v5/concepts/themes/
root.setThemes([
  am5themes_Animated.new(root)
]);


// Create chart
// https://www.amcharts.com/docs/v5/charts/xy-chart/
var chart = root.container.children.push(am5xy.XYChart.new(root, {
  panX: true,
  panY: true,
  wheelX: "panX",
  wheelY: "zoomXY",
  pinchZoomX: true,
  paddingLeft: 0,
  layout: root.verticalLayout
}));

chart.get("colors").set("step", 3);



// Create axes
// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
var xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
//   baseInterval: {
//     timeUnit: "day",
//     count: 1
//   },
  renderer: am5xy.AxisRendererX.new(root, {
    minorGridEnabled: false,
    // minGridDistance: 70,
    

    // strokeWidth:2
  }),
//   tooltip: am5.Tooltip.new(root, {})
}));


var yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
  maxDeviation: 0.2,
  renderer: am5xy.AxisRendererY.new(root, {
    minorGridEnabled: false,

  })
}));

// xAxis.get("renderer").grid.template.set("forceHidden", true);
// yAxis.get("renderer").grid.template.set("forceHidden", true);

yAxis.children.moveValue(am5.Label.new(root, { text: "Detector Response", rotation: -90, y: am5.p50, centerX: am5.p50 }), 0);
xAxis.children.push(am5.Label.new(root, { text: "Time", x: am5.p50, centerX: am5.p50 }));

xAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});
yAxis.get("renderer").grid.template.setAll({
  strokeOpacity: 0.1 // Adjust opacity (0 = fully transparent, 1 = fully visible)
});

const colorPalette = [
  "#1f77b4", "#2ca02c", "#d62728", "#9467bd", 
  "#8c564b", "#e377c2", "#bcbd22", "#17becf"
];
let seriesMap = {};

props.data.forEach((item, index) => {
  const key = Object.keys(item)[0];
  const seriesData = item[key];

  var series = chart.series.push(am5xy.LineSeries.new(root, {
    name: key.split('.').slice(0, -1).join('.'),
    xAxis: xAxis,
    yAxis: yAxis,
    valueYField: "y",
    valueXField: "x",
    visible: key === props.initialVisibleChart,
    stroke: am5.color(colorPalette[index % colorPalette.length]),
  }));

  series.strokes.template.setAll({
    strokeWidth: 1.6, // Adjust thickness
  });

  series.data.setAll(seriesData);
  seriesMap[key] = series;

});




var legend = chart.children.unshift(am5.Legend.new(root, {
  y:am5.p0,
  centerY:am5.p50,
  paddingLeft:70,
})); 
legend.data.setAll(chart.series.values);




function addBullet(x, type, name, tc, index, active) {
  const targetSeries = seriesMap[props.initialVisibleChart];
  if (!targetSeries) return;


  targetSeries.events.once("datavalidated", function() {
  
      var axisPosition = xAxis.valueToPosition(x);
      var seriesDataItem = xAxis.getSeriesItem(targetSeries, axisPosition, 0);

  
      // Create bullet
      if (seriesDataItem) {
        var bullet = am5.Container.new(root, {
        });
         if (type === "Peak") {
          var circle = bullet.children.push(am5.Circle.new(root, {
            radius: 8,
            fill: active ? am5.color(0xF48735) : am5.color(0x06b6d4),
            stroke: targetSeries.get("stroke"),
            strokeWidth: 1.7,
            centerY: am5.p50,
            centerX: am5.p50,
            // cursorOverStyle: "pointer",
            tooltip: am5.Tooltip.new(root, {
              // keepTargetHover: true,
              // interactive: true,
              // labelHTML: "<button onclick={()=> console.log(here)}>test</button>"
              
            }),
            tooltipText: `${name}\n\nx:{valueX}\ny:{valueY}`,
            tooltipY:-30,
            // tooltipHTML: '<button onclick={()=> console.log(here)}>test</button>'
            // showTooltipOn: "always",
          }));
  
  
  
          circle.events.on('click', function(ev){
            if (props.onPeakNameClick) {
              props.onPeakNameClick(index);
              // circle.set("cursorOverStyle", 'default');
          }
            // console.log(name)
              // console.log('clicked', ev.target.dataItem)
              // circle.set("tooltipText", `${peakName}\n\nx:{valueX}\ny:{valueY}`);
          });

          // circle.events.on('pointerover', function(ev){
          //   console.log(name)
          //     // console.log('clicked', ev.target.dataItem)
          //     // circle.set("tooltipText", `${peakName}\n\nx:{valueX}\ny:{valueY}`);
          // });
  
          var label = bullet.children.push(am5.Label.new(root, {
            text: name,
            centerX: am5.p50,
            centerY: am5.p100,
            dx: 0,
            dy:-10,
            
          }));
        }
  
        targetSeries.addBullet(seriesDataItem, am5.Bullet.new(root, {
          sprite: bullet
        }));
      }
    });
  }


  if (props.reportingPeaks) {
    props.reportingPeaks.map((peak, index) => {
      if (peak.show) {
        addBullet(peak.peak, "Peak", peak.name, peak.tc, index, peak.active);
      }
    });
  }
  


return () => {
  root.dispose();
};
  },[props]);


  return (
    <>
      <div id="chartdiv" style={{width:'100%', height: '100%'}}></div>
    </>
  );
}
export default LineChartPeaksPreview;